import { Outlet } from 'react-router';
import { DefaultErrorBoundary } from '~/shell/components/DefaultErrorBoundary';

/**
 * The content layout for the application.
 * Currently only renders the outlet and makes sure that the default error boundary is used inside the common layout.
 */
export default function ContentLayoutRoute() {
  return <Outlet />;
}

export function ErrorBoundary() {
  return <DefaultErrorBoundary />;
}
